import {
  ABOUT_BUSINESS,
  BENEFITS,
  QUALIFICATIONS,
  RESPONSIBILITIES,
} from 'src/app/constants/formDataFields';
import {
  PAGE_ID_CLASSIFY,
  PAGE_ID_MANAGE,
  PAGE_ID_PAY_AND_POST,
  PAGE_ID_SELECT_AD_TYPE,
  PAGE_ID_WRITE,
} from 'src/app/constants/pageUid';
import { PaymentOption } from 'src/app/constants/paymentOptions';
import { invertObject } from 'src/app/utils/invertObject';
import {
  DraftJobFlowType,
  GuidedDetailsType,
  DraftJobPaymentOption,
  SalaryType,
  WorkType,
  DraftJobProgress,
} from 'src/graphql/generated';
import { CajaWorkType } from 'src/types/cajaWorkType';
import type { FlowType } from 'src/types/jobFlow';
import { PayType } from 'src/types/salaryTypes';

export const flowTypeUIToGraphQL: Record<
  Exclude<FlowType, 'refresh'>,
  DraftJobFlowType
> = {
  create: DraftJobFlowType.CREATE,
  edit: DraftJobFlowType.EDIT,
  multilocation: DraftJobFlowType.MULTILOCATION,
};

export const guidedDetailsTypeUIToGraphQL: Record<string, GuidedDetailsType> = {
  [ABOUT_BUSINESS]: GuidedDetailsType.ABOUT_BUSINESS,
  [BENEFITS]: GuidedDetailsType.BENEFITS,
  [QUALIFICATIONS]: GuidedDetailsType.QUALIFICATIONS,
  [RESPONSIBILITIES]: GuidedDetailsType.RESPONSIBILITIES,
};

export const paymentOptionUIToGraphQL: Record<string, DraftJobPaymentOption> = {
  [PaymentOption.CREDIT_CARD]: DraftJobPaymentOption.CREDIT_CARD,
  [PaymentOption.SAVED_CREDIT_CARD]: DraftJobPaymentOption.SAVED_CREDIT_CARD,
  [PaymentOption.INVOICE]: DraftJobPaymentOption.INVOICE,
  [PaymentOption.CONTRACT]: DraftJobPaymentOption.CONTRACT,
};

export const payTypeUIToGraphQL: Record<PayType, SalaryType> = {
  [PayType.ANNUAL_PACKAGE]: SalaryType.ANNUAL_PACKAGE,
  [PayType.ANNUAL_COMMISSION]: SalaryType.ANNUAL_COMMISSION,
  [PayType.COMMISSION_ONLY]: SalaryType.COMMISSION_ONLY,
  [PayType.MONTHLY]: SalaryType.MONTHLY,
  [PayType.HOURLY_RATE]: SalaryType.HOURLY_RATE,
};

export const workTypeUIToGraphQL: Record<CajaWorkType, WorkType> = {
  [CajaWorkType.FullTime]: WorkType.FULLTIME,
  [CajaWorkType.PartTime]: WorkType.PARTTIME,
  [CajaWorkType.Contract]: WorkType.CONTRACT_TEMP,
  [CajaWorkType.Casual]: WorkType.CASUAL,
};

export const draftProgressUIToGraphQL: Record<string, DraftJobProgress> = {
  [PAGE_ID_CLASSIFY]: DraftJobProgress.CLASSIFY,
  [PAGE_ID_SELECT_AD_TYPE]: DraftJobProgress.SELECT_AD_TYPE,
  [PAGE_ID_WRITE]: DraftJobProgress.WRITE,
  [PAGE_ID_MANAGE]: DraftJobProgress.MANAGE,
  [PAGE_ID_PAY_AND_POST]: DraftJobProgress.PAY_AND_POST,
};

export const flowTypeGraphQLToUI = invertObject(flowTypeUIToGraphQL);
export const guidedDetailsTypeGraphQLToUI = invertObject(
  guidedDetailsTypeUIToGraphQL,
);
export const paymentOptionGraphQLToUI = invertObject(paymentOptionUIToGraphQL);
export const payTypeGraphQLToUI: Record<SalaryType, PayType> = {
  [SalaryType.ANNUAL_PACKAGE]: PayType.ANNUAL_PACKAGE,
  [SalaryType.ANNUAL_COMMISSION]: PayType.ANNUAL_COMMISSION,
  [SalaryType.COMMISSION_ONLY]: PayType.ANNUAL_COMMISSION, // <=== UI no longer supports selecting COMMISSION_ONLY. However if graph returns COMMISSION_ONLY, map to ANNUAL_COMMISSION for UI
  [SalaryType.MONTHLY]: PayType.MONTHLY,
  [SalaryType.HOURLY_RATE]: PayType.HOURLY_RATE,
};
export const workTypeGraphQLToUI = invertObject(workTypeUIToGraphQL);
export const draftProgressGraphQLToUI = invertObject(draftProgressUIToGraphQL);
